import {
  getItem,
  setItem,
  removeItem
} from '@/untils/storage'
import Bus from '@/api/Bus.js'
import { userMenuTree,menuTree } from '@/api/menu'
import store from './index'
const user = {
  state: {
    token: getItem('token'),
    userId: '',
    userCode: '',
    name: '',
    email: '',
    qq: '',
    invite: '',
    role: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ID: (state, id) => {
      state.userId = id
    },
    SET_USER_CODE: (state, userCode) => {
      state.userCode = userCode
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_QQ: (state, qq) => {
      state.qq = qq
    },
    SET_INVITE: (state, invite) => {
      state.invite = invite
    },
    SET_ROLE: (state, role) => {
      state.role = role
      Bus.$emit('watchrole')
      //console.log(state.role,'Bus')
    },

  },

  actions: {
    // 获取用户信息
    GetInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        menuTree().then(response => {
          const data = response.data.data
          //console.log(response,'userStore')
          if (data) { // 验证返回是否有值

            commit('SET_ROLE', data)
          } else {
            reject(new Error('用户必须有权限 !'))
          }
          /*commit('SET_ID', data.userId)
          commit('SET_USER_CODE', data.userCode)
          commit('SET_NAME', data.name)
          commit('SET_EMAIL', data.email)
          commit('SET_QQ', data.qq)
          commit('SET_INVITE', data.invite)*/
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        /*commit('SET_TOKEN', '')
        commit('SET_ID', '')
        commit('SET_USER_CODE', '')
        commit('SET_NAME', '')
        commit('SET_EMAIL', '')
        commit('SET_QQ', '')
        commit('SET_INVITE', '')*/
        commit('SET_ROLE', [])
        removeItem('token')
        removeItem('userInfo')
        Bus.$emit('watchUser')
        resolve()
      })
    },


  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/user.js